import { useQuery } from "@tanstack/vue-query";
import { type MaybeRef } from "@vueuse/core";
import { api } from "@/api";
import { STORAGE_QUERY_KEY, type StorageCompound } from "./storage";

export const getStorageCompound = async (siteId: string) => {
  const { body } = await api.get<StorageCompound>(`/storage/sites/${siteId}`);
  return body;
};

/** The compound plan and every pitch's current outfit. Polls, like the bookings list. */
export const useStorageCompound = (siteId: MaybeRef<string | null>) =>
  useQuery({
    queryKey: [STORAGE_QUERY_KEY, "compound", siteId] as const,
    queryFn: ({ queryKey: [, , siteId_] }) =>
      getStorageCompound(unref(siteId_) as string),
    enabled: computed(() => !!unref(siteId)),
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: false,
  });
